import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ThemeBox from '../containers/theme/ThemeBox';

import Footer from '../components/Footer';

class Theme extends Component {
  state = {};

  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const themeList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        themeList,
      });
    }
  };
  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/theme', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderTheme = () => {
    const { themeList } = this.state;

    const list = themeList.map((item, index) => {
      return (
        <ThemeBox
          key={index}
          themeSerial={item.themeSerial}
          title={item.title}
          comment={item.comment}
          imageS={item.imageS}
        />
      );
    });

    return list;
  };

  render() {
    const { themeList } = this.state;
    return (
      <Fragment>
        <div className="content">
          <div className="padding_70" style={{ paddingTop: 100 }}>
            {themeList ? this._renderTheme() : null}
          </div>
        </div>

        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Theme));
